import { render, staticRenderFns } from "./CustomSpace.vue?vue&type=template&id=189c7f82&scoped=true"
import script from "./CustomSpace.vue?vue&type=script&lang=js"
export * from "./CustomSpace.vue?vue&type=script&lang=js"
import style0 from "./CustomSpace.vue?vue&type=style&index=0&id=189c7f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c7f82",
  null
  
)

export default component.exports